import { createContext } from 'react'
import type { SchemaData } from '../schema/types'

/**
 * `undefined` means "no provider above"; `null` means "provider present,
 * schema still loading". The two are deliberately distinct — `useSchema`
 * throws on the first and returns null on the second, and collapsing them
 * would turn a missing provider into a silent permanent loading state.
 *
 * Lives apart from the provider component so neither the context nor the
 * hooks force a Fast Refresh remount of the other (TASK-570), matching
 * the split `metroMapStoreContext` / `useMetroMapStore` /
 * `MetroMapStoreProvider` already uses.
 */
export const SchemaContext = createContext<SchemaData | null | undefined>(undefined)
